import { FC } from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { useCountryNamesTranslations } from '~src/country/country-names';
import { SelectInputV2 } from '~src/ui/select-input-v2';

interface CountryInputProps {
  countryName: string;
}

export const CountryInput: FC<CountryInputProps> = ({ countryName }) => {
  const { translate } = useCountryNamesTranslations();
  const { tICU } = useTranslations();

  const countryNameTranslated = translate(countryName);

  const countryOptions = [{ value: countryNameTranslated, label: countryNameTranslated }];

  return (
    <SelectInputV2
      name="country"
      label={tICU('widget.delivery_address.COUNTRY_PLACEHOLDER')}
      autoComplete="country-field"
      disabled
      dataTest="country-input"
      options={countryOptions}
      isRequired
    />
  );
};
